import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {Button, Checkbox, FormControlLabel, makeStyles, Tooltip} from '@material-ui/core';
import {isIncludedInOrderingList} from '@cabinet-packages/helpers';
import {
    AddRemoveIconButtons,
    ConfirmDialog,
    CustomDialog,
    Loading,
    LoadOrderResultDialog
} from '@cabinet-packages/components';
import {useDispatch, useSelector} from 'react-redux';
import {
    addAssayToOrderList,
    clearOrderedAssays,
    clearTakesFromBasket,
    getCatalog,
    setPromoCode,
} from '@cabinet-packages/redux';
import TextField from "@material-ui/core/TextField";
import themeMaterialUI from "../settings/themeMaterialUI";
import {setGoToCollectionPoints} from "@cabinet-packages/redux/actions/actionsCreators";
import {getPromo} from "@cabinet-packages/api/api";
import HowToPrepare from "./HowToPrepare";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        maxWidth: '900px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        height: 'max-content',
        minHeight: '100%',
    },
    rootForShop: {
        width: '100%',
        height: 'max-content',
        minHeight: '100%',
        maxWidth: '900px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    innerWrapper: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        maxHeight: "calc(100vh - 50px)",
        overflowY: "auto",
    },
    orderHeader: {
        width: '100%',
        height: '50px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
    },
    orderHeaderText: {
        color: 'rgba(0, 0, 0, 0.6)',
        '@media (max-width: 1140px)': {
            fontSize: '1rem',
        }
    },
    orderCatalog: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
    },
    listHeadersContainer: {
        background: theme.palette.primary.main,
        color: 'white',
        display: 'grid',
        gridTemplateColumns: '55% 15% 15% 15%',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        boxSizing: 'border-box',
        overflow: 'hidden',

        '@media (max-width: 1140px)': {
            gridTemplateColumns: '55% 15% 30%',

            '& :nth-child(2)': {
                display: 'none',
            },
        },
    },
    listHeader: {
        fontSize: '15px',
        display: 'flex',
        justifyContent: 'space-around',
        textAlign: 'center',
        alignItems: 'center',
        position: 'relative',
        borderRight: '1px solid rgba(255, 255, 255, 0.2)',
        "&:last-child": {
            borderRight: 'none',
        },
    },
    listHeaderAssayName: {
        fontSize: '15px',
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'row',
        textAlign: 'center',
        alignItems: 'center',
        position: 'relative',
        borderRight: '1px solid rgba(255, 255, 255, 0.2)',
        paddingLeft: '8px',

        "&:last-child": {
            borderRight: 'none',
        },
    },
    listHeaderRedDiscount: {
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        fontSize: '24px',
        fontWeight: '600',
        color: 'white',
        background: theme.palette.error.light,
        border: `2px solid ${theme.palette.error.main}`,
        borderRadius: '16px',
        width: '32px',
        height: '32px',
        position: 'absolute',
        top: 3,
        right: 0,
    },
    listHeaderTinyText: {
        fontSize: '10px',
    },
    listBody: {
        width: '100%',
        height: 'max-content',
        marginTop: '8px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        border: '2px solid rgba(0, 0, 0, 0.1)',
    },
    list: {
        scrollBehavior: 'smooth',
        boxShadow: '0 0 1px 1px rgba(0, 0, 0, 0.1)',
        '&:focus': {
            outline: 'none',
        },
    },
    listItem: {
        display: 'grid',
        gridTemplateColumns: '55% 15% 15% 15%',
        textAlign: 'center',
        boxSizing: 'border-box',

        '@media (max-width: 1140px)': {
            gridTemplateColumns: '55% 15% 30%',
        },
    },
    listItemTitle: {
        borderRight: '1px solid rgba(0, 0, 0, 0.1)',
        fontSize: '16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        padding: '5px',
        textAlign: 'start',
        cursor: 'pointer',
        boxSizing: 'border-box',

        '@media (max-width: 1140px)': {
            fontSize: '14px',
            wordBreak: 'break-all',
        },
    },
    listItemTitleForTake: {
        borderRight: '1px solid rgba(0, 0, 0, 0.1)',
        height: 'inherit',
        fontSize: '16px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '5px',
        textAlign: 'start',
        boxSizing: 'border-box',

        '@media (max-width: 1140px)': {
            fontSize: '14px',
            wordBreak: 'break-all',
        },
    },
    listItemGroupTitle: {
        borderRight: '1px solid rgba(0, 0, 0, 0.1)',
        fontSize: '16px',
        letterSpacing: '1px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        height: '100%',
        padding: '5px',
        '@media (max-width: 1140px)': {
            padding: '5px 5px 5px 5%',
        },
    },
    listItemTime: {
        borderRight: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '5px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        '@media (max-width: 1140px)': {
            display: 'none',
        },
    },
    listItemPrice: {
        borderRight: '1px solid rgba(0, 0, 0, 0.1)',
        display: 'flex',
        userSelect: 'none',
        padding: '5px',
        flexDirection: 'column',
        justifyContent: 'space-around',
    },
    listItemPriceWithDiscount: {
        borderLeft: '2px solid rgba(0, 0, 0, 0.1)',
        padding: '5px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',

        '@media (max-width: 1140px)': {
            lineHeight: '100%',
        },
    },
    listItemPriceNumber: {
        alignSelf: 'center',
        color: theme.palette.error.main,
    },
    listItemHeaderOfGroup: {
        background: theme.palette.primary.main,
        color: 'rgb(70, 70, 70)',
    },
    addRemoveButton: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    orderPriceContainer: {
        height: '140px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        boxSizing: 'border-box',
    },
    orderPriceCalc: {
        height: '90px',
        display: 'grid',
        gridTemplateColumns: '85% 15%',

        '@media (max-width: 1140px)': {
            gridTemplateColumns: '70% 30%',
        },
    },
    orderPriceCalcWrapper: {
        borderRight: '1px solid rgba(0, 0, 0, 0.1)',
    },
    orderPriceCalcItem: {
        height: '30px',
        padding: '4px 8px',
        alignSelf: 'center',
        textAlign: 'center',
    },
    orderPriceCalcItemText: {
        height: '30px',
        padding: '4px 8px',
        alignSelf: 'center',
    },
    orderPriceCalcItemMain: {
        height: '30px',
        padding: '4px 8px',
        paddingRight: 0,
        alignSelf: 'center',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    orderPriceCalcFullPrice: {
        width: '17.65%',
        textAlign: 'center',

        '@media (max-width: 1140px)': {
            width: 'auto',
            paddingRight: '4px',
        },
    },
    orderPriceTotal: {
        height: '50px',
        width: '100%',
        display: 'grid',
        gridTemplateColumns: '85% 15%',
        background: 'rgba(0, 0, 0, 0.07)',

        '@media (max-width: 1140px)': {
            gridTemplateColumns: '70% 30%',
        },
    },
    orderPriceTotalText: {
        padding: '4px 8px',
        alignSelf: 'center',
        height: '100%',
        lineHeight: '42px',
        borderRight: '1px solid rgba(0, 0, 0, 0.1)',
    },
    orderPriceTotalValue: {
        padding: '4px 8px',
        alignSelf: 'center',
        height: '100%',
        lineHeight: '42px',
        color: theme.palette.error.light,
        textAlign: 'center',
    },
    orderActionContainer: {
        height: 'max-content',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        position: 'sticky',
        bottom: 0,
        left: 0,
        background: 'white',
        '@media (max-width: 1140px)': {
            paddingBottom: '75px'
        },
    },
    orderActionItem: {
        height: '50px',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '4px 8px',
        '& a': {
            color: theme.palette.error.light,
        }
    },
    orderActionTooltip: {
        fontSize: '1rem',
    },
    requiredWrapperText: {
        padding: 5,
    },
    orderActionItemPromo: {
        height: '50px',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        padding: '4px 8px',
        '@media (max-width: 1140px)': {
            flexDirection: 'column',
            height: 'max-content'
        },
    },
    orderActionItemPromoCodeContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',

        '@media (max-width: 1140px)': {
            flexDirection: 'column',
        },
    },
    commentary: {
        margin: 0,
    },
    orderActionItemPromoCodeButton: {
        height: '100%',
    },
    orderInfoTextWrapper: {
        height: '90px',
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        marginTop: '8px',
    },
    orderInfoText: {
        fontSize: '1.17rem',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '8px',
        maxWidth: '600px',
        textAlign: 'center',
        alignSelf: 'center',
        '@media (max-width: 1140px)': {
            fontSize: '1rem',
        },
    },
    orderActionButtonsWrapper: {
        width: '100%',
        height: '50px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',

        '@media (max-width: 1140px)': {
            height: 'max-content',
        },
    },
    orderActionButtonsInnerWrapper: {
        width: '100%',
        maxWidth: '600px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: '8px',

        '@media (max-width: 1140px)': {
            flexDirection: 'column',
        },
    },
    orderActionButton: {
        width: '196px',

        '@media (max-width: 1140px)': {
            width: '95%',
            margin: '4px auto',
        },
    },
    redButton: {
        color: '#e41e15',
        width: '196px',

        '@media (max-width: 1140px)': {
            width: '95%',
            margin: '4px auto',
        },
    },
    error: {
        color: theme.palette.error.light,
        textAlign: 'center',
        padding: '8px',
    },
    loading: {
        width: '80px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
    },
    promoCode: {
        color: theme.palette.primary.main,
        textAlign: 'center',
        padding: '8px',
        '@media (max-width: 1140px)': {
            padding: 0,
        },
    },
    listForComplexFillings: {
        listStylePosition: 'inside',
    },
    complexFillings: {
        fontSize: '13px',
        color: 'rgba(0, 0, 0, 0.6)',
    },
}));

const OrderManager =({isComponentInShop}) => {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();
    const {catalog, complexResearch, actions, takeId}  = useSelector(state => state.assaysCatalog);
    const fullCatalog = catalog && complexResearch && actions && [...catalog, ...complexResearch, ...actions];
    const { orderingList, totalPrice, amountOfItems, goToCollectionPoints, promoCode } = useSelector(state => state.orderAssays);
    const [value, setValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [isUsedPromo, setIsUsedPromo] = useState(false);
    const [isUsedClearTakes, setIsUsedClearTakes] = useState(false);
    const { activePatient } = useSelector(state => state.patients);
    const [checkboxState, setCheckboxState] = useState({
        checkedA: false,
        checkedB: !!promoCode,
        checkedC: false,
    });
    const createAssaysData = (ids) => catalog && complexResearch && actions && ids.map(currId => (
        fullCatalog.find(currAssay => +currAssay.id === +currId.id && currAssay.type === currId.type && !currAssay.superGroupName)));

    const filteredState = catalog && complexResearch && actions && createAssaysData(orderingList);

    const fullPrice = catalog && complexResearch && actions && filteredState.reduce((acu, cur) => {
        return acu + cur.price;
    },0);

    const prevOrderingList = orderingList;


    const handleEditOrderingList = (event) => {
        if (event.target.name === "checkedA" && event.target.checked === true) {
            dispatch(clearTakesFromBasket());
        }
        if (event.target.name === "checkedA" && event.target.checked === false) {
            dispatch(clearOrderedAssays());

            prevOrderingList.forEach(assay => {
                const findAssay = fullCatalog.find(item => item.type === assay.type && +item.id === +assay.id);

                dispatch(addAssayToOrderList(findAssay.id,
                    findAssay.discount
                        ? Math.ceil(findAssay.price - findAssay.price * findAssay.discount / 100)
                        : findAssay.price,
                    ()=>{},
                    findAssay.type,
                ));
            })
        }
    };

    const handleChange = (event) => {
        if (event.target.name === "checkedA") {
            dispatch(setGoToCollectionPoints(event.target.checked));
            if (!event.target.checked && isUsedPromo) {
                setIsUsedPromo(false);
            }
        }
        if (event.target.name === "checkedB" && !event.target.checked) {
            dispatch(setPromoCode(null));
        }
        setCheckboxState({ ...checkboxState, [event.target.name]: event.target.checked });
        handleEditOrderingList(event);
    };

    const handleClearAll = (event) => {
        event.stopPropagation();
        event.preventDefault();

        const handleConfirm = () => {
            dispatch(clearOrderedAssays());
            dispatch(setGoToCollectionPoints(false));
        };

        CustomDialog(ConfirmDialog, {
            text: 'Очистити корзину?',
            onConfirm: handleConfirm,
        }, false, themeMaterialUI);
    };

    const handleGoBack = (event) => {
        event.stopPropagation();
        event.preventDefault();
        if (amountOfItems === 0) {
            isComponentInShop ? history.push('/shop') : history.push('/catalog-table')
        } else {
            history.goBack();
        }
    };

    const handleTransitionToCollectionPoints = (event) => {
        event.stopPropagation();
        event.preventDefault();

        if (checkboxState.checkedA && !goToCollectionPoints) {
            dispatch(setGoToCollectionPoints(true));
        }
        if (!checkboxState.checkedA && goToCollectionPoints) {
            dispatch(setGoToCollectionPoints(false));
        }

        isComponentInShop
            ? history.push('/shop-order-collection-points')
            : history.push('/order-collection-points')
    };


    const handleGetPromo = async (event) => {
        event.stopPropagation();
        event.preventDefault();
        if (promoCode) dispatch(setPromoCode(null));
        setLoading(true);
        setError(false);

        try {
            const promoValue = await getPromo(value);
            if (promoValue) dispatch(setPromoCode(promoValue));
        } catch (e) {
            setError('Вибачте, сталась помилка.');
        }

        setLoading(false);
    };

    const handleDeactivatePromo = (event) => {
        event.stopPropagation();
        event.preventDefault();

        if (checkboxState.checkedA) {
            handleChange({target: {name: 'checkedA', checked: false}})
        }

        dispatch(setPromoCode(null));
        createAssaysData(orderingList).forEach((assay, idx) => {
            if (idx === 0) dispatch(clearOrderedAssays());
            if (assay.idParent !== takeId) {
                dispatch(addAssayToOrderList(assay.id,
                    assay.discount
                        ? Math.ceil(assay.price - assay.price * assay.discount / 100)
                        : assay.price,
                    () => {},
                    assay.type));
            }
        });
        setIsUsedPromo(false);
    }

    useEffect(() => {
        if (orderingList && catalog && actions && complexResearch && filteredState) {
            const items = filteredState
                .map(item => ({
                    id: item.id,
                    name: item.name,
                    variant: item.type,
                    price: item.discount
                        ? Math.ceil(item.price - item.price * item.discount / 100)
                        : item.price,
                    quantity: 1,
                }));

            // window.dataLayer.push({
            //     event: 'begin_checkout',
            //     eventProps: {
            //         items,
            //     },
            //     coupon: '',
            // });
        }
    }, []);

    useEffect(() => {
        if (promoCode && promoCode.type !== 'none' && !isUsedPromo && orderingList && catalog && complexResearch && actions) {
            if (!value || value.length === 0) setValue(promoCode.code)
            if (promoCode.type === 'all') {
                createAssaysData(orderingList).forEach((assay, idx) => {
                    if (idx === 0) dispatch(clearOrderedAssays());
                    if (assay.idParent !== takeId) {
                        dispatch(addAssayToOrderList(assay.id, Math.ceil(+assay.price - (+assay.price * (+promoCode.discount/100))), () => {
                        }, assay.type))
                    }
                });
                if (checkboxState.checkedA) handleChange({target: {name: 'checkedA', checked: true}});
                setIsUsedPromo(true);
            }
            if (promoCode.type === 'specified') {
                createAssaysData(orderingList).forEach((assay, idx) => {
                    if (idx === 0) dispatch(clearOrderedAssays());
                    if (assay.idParent !== takeId) {
                        const foundDiscount = promoCode.grtests.find(item => +item[0] === +assay.id);

                        if (foundDiscount) {
                            dispatch(addAssayToOrderList(
                                assay.id,
                                +foundDiscount[1] === 0 ? +foundDiscount[2] : Math.ceil(+assay.price - (+assay.price * (+foundDiscount[1]/100))),
                                () => {},
                                assay.type));
                        } else {
                            dispatch(addAssayToOrderList(
                                assay.id,
                                Math.ceil(+assay.price - (+assay.price * (+assay.discount/100))),
                                () => {},
                                assay.type));
                        }
                    }
                });
                if (checkboxState.checkedA) handleChange({target: {name: 'checkedA', checked: true}});
                setIsUsedPromo(true);
            }
            if (promoCode.type === 'notdisc') {
                createAssaysData(orderingList).forEach((assay, idx) => {
                    if (idx === 0) dispatch(clearOrderedAssays());
                    const discount = assay.opt && assay.opt.includes(promoCode.type) ? assay.discount : promoCode.discount;
                    if (assay.idParent !== takeId) {
                        dispatch(addAssayToOrderList(assay.id, Math.ceil(+assay.price - (+assay.price * (+discount/100))), () => {
                        }, assay.type))
                    }
                });
                if (checkboxState.checkedA) handleChange({target: {name: 'checkedA', checked: true}});
                setIsUsedPromo(true);
            }
        }
    }, [promoCode, isUsedPromo, orderingList, dispatch, checkboxState, takeId, value, catalog, complexResearch, actions]);

    useEffect(() => {
        if (goToCollectionPoints && !checkboxState.checkedA && !isUsedClearTakes) {
            handleChange({target: {name: 'checkedA', checked: true}});
            setIsUsedClearTakes(true);
        }
    }, [checkboxState, goToCollectionPoints, isUsedClearTakes]);

    useEffect(() => {
        if (!catalog && takeId) dispatch(getCatalog());
    }, [dispatch, catalog, takeId]);

    function RowRenderer(props) {
        const { index, style } = props;
        const item = filteredState[index];

        const newStyles = {
            ...style,
            background: index%2 === 0 ? 'none': 'rgba(0, 0, 0, 0.05)',
            borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        };

        const handleClickOnAssay = (event, isTake) => {
            event.stopPropagation();
            event.preventDefault();

            switch (item.type) {
                case "action": {
                    isComponentInShop
                        ? history.push(`/shop-actions-details/${item.id}`)
                        : history.push(`/actions-details/${item.id}`)
                    break;
                }
                case "complex": {
                    isComponentInShop
                        ? history.push(`/shop-complex-info/${item.id}`)
                        : history.push(`/complex-info/${item.id}`)
                    break;
                }
                case "assay": {
                    isComponentInShop
                        ? !isTake && history.push(`/shop-assay-info/${item.id}`)
                        : !isTake && history.push(`/assay-info/${item.id}`)
                    break;
                }
                default: {
                    return;
                }
            }
        }

        return (
            <div
                className={classes.listItem}
                style={{
                    ...newStyles,
                    textDecoration: 'none',
                    color: 'inherit',
                    height: 'max-content',
                }}
            >
                <div
                    className={item.idParent === 14 ? classes.listItemTitleForTake : classes.listItemTitle}
                    onClick={event => handleClickOnAssay(event, item.idParent === 14)}
                >
                    <p>
                        {item.name
                            ? takeId === 14 ? item.name : item.name.split(')')[0] + (item.name.indexOf('(') >= 0 ? ') ' : ' ')
                            : item.testNames.split(',')[0].split('\\\\').join('')
                        }
                    </p>
                    {item.type === 'complex' && <ol className={classes.listForComplexFillings}>
                        {[...(item?.filling || []), ...(item?.idGrTest || [])].map((fill, idx) => (<li
                            key={fill.id + ' ' + idx}
                            className={classes.complexFillings}
                        >
                            {fill.name}
                        </li>))}
                    </ol>
                    }
                </div>
                <div className={classes.listItemTime}>
                    {item.duration_day}
                </div>
                <div className={classes.listItemPrice}>
                    {item.price && +item.price}
                </div>
                <div className={classes.listItemPriceWithDiscount}>
                    <div className={classes.listItemPriceNumber}>
                        {item.discount
                            ? Math.ceil(item.price && (item.price - item.price * item.discount / 100))
                            : item.price && item.price
                        }
                    </div>
                    <div className={classes.addRemoveButton}>
                        {item.idParent !== 14
                            ? <AddRemoveIconButtons
                                item={item}
                                isIncludedInOrderingList={isIncludedInOrderingList(item, orderingList)}
                                handleChecked={checkboxState.checkedA ? handleChange : null}
                                isInBasket={true}
                                ceil={true}
                            />
                            : <div style={{width: '48px'}}/>}
                    </div>
                </div>
            </div>
        );
    }

    const NoRowRenderer = () => (<div>
        <div style={{ background: takeId === 14 ? '#FFC100' : '#0077c85e',}}>
            <div className={classes.listItemGroupTitle}>
                <p>Чомусь у Вашому кошику ще нічого немає <span role="img" aria-label="Emoji.">🧐</span>.</p>
            </div>
        </div>
    </div>);

    const getAssayRowHeight = (index, width) => {
        const name = filteredState[index].name
            ? takeId === 14 ? filteredState[index].name : (filteredState[index].name.split(')')[0] + (filteredState[index].name.indexOf('(') >= 0 ? ') ' : ' '))
            : (filteredState[index].testNames.split(',')[0].split('\\\\').join(''));

        const symbolWidth = 16;
        const lineHeight = 14;
        const result = Math.ceil((name.length*symbolWidth)/(width/2)) * lineHeight;

        return result > 50 ? result : 50;
    };

    const printCheck = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const data = {
            fullname: `${activePatient && activePatient.lastname && activePatient.lastname} ${activePatient && activePatient.firstname && activePatient.firstname} ${activePatient && activePatient.fathername && activePatient.fathername}`,
            idClient: activePatient ? activePatient.id : 0,
            dt: new Date().toISOString().slice(0, 10),
            price: fullPrice,
            priceDiscount: totalPrice,
            services: createAssaysData(orderingList).map((item, idx) => ({
                idPacket: item.id,
                idConf: item.idConf,
                price: item.price,
                packetName: item.name
                    ? takeId === 14 ? item.name : item.name.split(')')[0] + (item.name.indexOf('(') >= 0 ? ') ' : ' ')
                    : item.testNames.split(',')[0].split('\\\\').join(''),
                priceDiscount: item.discount
                    ? Math.ceil((item.price - item.price * item.discount / 100))
                    : item.price,
                discount: item.discount,
                amount: 1,
                debt: 0,
                analises: item.type === "complex"
                    ? item.filling.map(assay => assay.name)
                    : [],
                durationDay: item.duration_day,
            })),
        }

        CustomDialog(LoadOrderResultDialog,
            {open: true, activePatient: activePatient ? activePatient : {lastname: "Он-лайн", firstname: 'замовлення', fathername: '' },
                themeMaterialUI, isCheck: data},
            false,
            themeMaterialUI);
    }

    return (catalog && complexResearch && actions
            ? <div className={isComponentInShop ? classes.rootForShop : classes.root}>
                <div className={classes.innerWrapper}>
                    <div className={classes.orderHeader}>
                        <h3 className={classes.orderHeaderText}>
                            Перелік аналізів, які Ви вже обрали
                        </h3>
                    </div>
                    <div className={classes.orderCatalog}>
                        <div className={classes.listHeadersContainer}>
                            <div className={classes.listHeaderAssayName}>
                                <p>
                                    Назва дослідження
                                </p>
                            </div>
                            <div className={classes.listHeader}>
                                <p>
                                    Термін виконання,
                                    <span className={classes.listHeaderTinyText}> робочих днів</span>
                                </p>
                            </div>
                            <div className={classes.listHeader}>
                                <p>
                                    Ціна, грн
                                </p>
                            </div>
                            <div className={classes.listHeader}>
                                <p>
                                    Ціна <br/> онлайн, <br/> грн
                                </p>
                                <span className={classes.listHeaderRedDiscount}>%</span>
                            </div>
                        </div>
                        <div className={classes.listBody}>
                            {amountOfItems === 0 && <NoRowRenderer/>}
                            {
                                filteredState && filteredState.map((item, idx) => {

                                    return (<RowRenderer
                                        index={idx}
                                        key={item.id}
                                        style={{height: getAssayRowHeight(idx, 900)}}
                                    />);
                                })
                            }
                        </div>
                        <div className={classes.orderPriceContainer}>
                            <div className={classes.orderPriceCalc}>
                                <div className={classes.orderPriceCalcWrapper}>
                                    <div className={classes.orderPriceCalcItemMain}>
                                        <div>Сума:</div>
                                        <div className={classes.orderPriceCalcFullPrice}>{fullPrice.toFixed(2)}</div>
                                    </div>
                                    <div className={classes.orderPriceCalcItemText}>
                                        Знижка при оплаті онлайн
                                    </div>
                                    <div className={classes.orderPriceCalcItemText}>
                                        Знижка за промокодом
                                    </div>
                                </div>
                                <div>
                                    <div className={classes.orderPriceCalcItem}>
                                        {totalPrice}
                                    </div>
                                    <div className={classes.orderPriceCalcItem}>
                                        {promoCode && promoCode.type !== 'none' ? '0.00' : (fullPrice - totalPrice).toFixed(2)}
                                    </div>
                                    <div className={classes.orderPriceCalcItem}>
                                        {promoCode && promoCode.type !== 'none' ? (fullPrice - totalPrice).toFixed(2) : '0.00'}
                                    </div>
                                </div>
                            </div>
                            <div className={classes.orderPriceTotal}>
                                <div className={classes.orderPriceTotalText}>
                                    Сума до оплати
                                </div>
                                <div className={classes.orderPriceTotalValue}>
                                    {totalPrice}
                                </div>
                            </div>
                        </div>
                        <div className={classes.orderActionContainer}>
                            <div className={classes.orderActionItem}>
                                <Tooltip title={<HowToPrepare/>} arrow>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checkboxState.checkedC}
                                            disabled={amountOfItems === 0}
                                            onChange={handleChange}
                                            name="checkedC"
                                            color="primary"
                                        />
                                    }
                                    label={<p>Даю згоду на <a href="#how_to_prepare">обробку моїх персональних даних</a>*</p>}
                                />
                                </Tooltip>

                            </div>
                            <div className={classes.orderInfoTextWrapper}>
                                <div className={classes.orderInfoText}>
                                    УВАГА! Усі обрані дослідження необхідно здати під час одного візиту.
                                </div>
                            </div>
                            <div className={classes.orderActionButtonsWrapper}>
                                <div className={classes.orderActionButtonsInnerWrapper}>
                                    <Button
                                        variant="outlined"
                                        className={classes.orderActionButton}
                                        color="secondary"
                                        onClick={(event) => handleClearAll(event)}
                                        disabled={amountOfItems === 0}
                                    >
                                        відмінити все
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        className={classes.redButton}
                                        color="inherit"
                                        onClick={(event) => handleGoBack(event)}
                                    >
                                        продовжити вибір
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        className={classes.orderActionButton}
                                        color="primary"
                                        onClick={(event) => handleTransitionToCollectionPoints(event)}
                                        disabled={amountOfItems === 0 || !checkboxState.checkedC}
                                    >
                                        замовити дослідження
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            : <Loading/>
    );
};

export default OrderManager;
